import {
  addFavorite,
  removeFavorite,
  setFavorites,
} from "store/favorites/favoritesSlice";
import { getToken } from "helpers/tokenHelpers"; // Utility to get auth token
import { getUserType } from "helpers/userTypeHelpers";

import { API_BASE_URL } from 'config';

const baseUrl= API_BASE_URL;

// Thunk to toggle favorites
export const toggleAddToFavorite = (space, userType) => async (dispatch) => {
  const authToken = getToken();

  if (userType === "provider") {
    dispatch(setFavorites([]));
    localStorage.setItem("favorites", JSON.stringify([]));
    return { success: true, message: "Favorites cleared for provider." };
  }

  if (userType === "guest" || !userType) {
    let favorites = JSON.parse(localStorage.getItem("favorites")) || [];

    const exists = favorites.some((fav) => fav.id === space.id);
    if (!exists) {
      favorites.push(space); // Save the entire space object
      dispatch(addFavorite(space));
    } else {
      favorites = favorites.filter((fav) => fav.id !== space.id);
      dispatch(removeFavorite({ id: space.id }));
    }

    localStorage.setItem("favorites", JSON.stringify(favorites));

    return {
      success: true,
      message: exists
        ? "Removed from favorites locally."
        : "Added to favorites locally.",
    };
  }

  if (userType === "seeker" && authToken) {
    try {
      // Use GET method and pass parameters in the query string
      const url = `${baseUrl}users/add-to-favorite?id=${space.uuid}`;
      const response = await fetch(url, {
        method: "GET", // Changed from POST to GET
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },
      });

      if (!response.ok) {
        throw new Error("Failed to toggle favorite.");
      }

      const result = await response.json();

      if (result.message === "Added to favorite") {
        dispatch(addFavorite(space));
      } else if (result.message === "Removed from favorites") {
        dispatch(removeFavorite({ id: space.id }));
      }

      return { success: true, message: result.message || "Toggled favorite." };
    } catch (error) {
      console.error("Error:", error.message);
      throw error;
    }
  }
};

// Thunk to fetch favorites
export const fetchFavorites = (authToken, userType) => async (dispatch) => {
  if (userType === "provider") {
    dispatch(setFavorites([]));
    localStorage.setItem("favorites", JSON.stringify([]));
    return { success: true, message: "No favorites for provider." };
  }

  if (userType === "seeker") {
    try {
      const response = await fetch(`${baseUrl}users/favorites`, {
        method: "GET", // Changed from POST to GET
        headers: {
          Authorization: `Bearer ${authToken}`,
          Accept: "application/json",
        },
      });
      if (!response.ok) throw new Error("Failed to fetch favorites.");

      const data = await response.json();
      dispatch(setFavorites(data.data));
    localStorage.setItem("favorites", JSON.stringify(data.data));
      return { success: true, message: "Favorites fetched successfully." };
    } catch (error) {
      console.error("Error fetching favorites:", error.message);
      return { success: false, message: "Error fetching favorites." };
    }
  }

  const localFavorites = JSON.parse(localStorage.getItem("favorites")) || [];
  dispatch(setFavorites(localFavorites));
  return {
    success: true,
    message: "Loaded favorites from localStorage.",
  };
};
